import React, { useEffect, useState, useCallback } from "react";
import PageHeaderAlt from "components/layout-components/PageHeaderAlt";
import { Button, Row, Col, Checkbox, message, Input, Form, Switch, Space } from "antd";
import ResponsiveModal from "components/shared-components/ResponsiveModal";
import { PlusOutlined, } from "@ant-design/icons";
import Flex from "components/shared-components/Flex";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from 'services/apiClient';
import { useMyContext } from "Context/MyContextProvider";
import Search from "antd/es/input/Search";
import { ErrorExtractor } from "../CustomUtils.js/utils";
import CommionPermissons from "../Utils/CommionPermissons";

const VIEW_LIST = "LIST";

const ItemHeader = ({ name, category }) => (
    <div>
        <h4 className="mb-0">{name}</h4>
        <span className="text-muted">{category}</span>
    </div>
);

export const PermissionData = async (api, authToken, id) => {
    try {
        const response = await apiClient.get(`${api}role-permission/${id}`, {
            headers: {
                Authorization: "Bearer " + authToken,
            },
        });
        return response.data;
    } catch (error) {
        const err = error.response.data.message || error.response.data.error || "An error occurred while fetching permissions.";
        message.error(err);
    }
};
const RolePermission = () => {
    const { Permisson, api, authToken } = useMyContext()
    const UserPermission = Permisson;
    const { id } = useParams();
    const { role_name } = useParams();

    const [view, setView] = useState('Accordion'); // Set default view
    const [permission, setPermission] = useState([]);
    const [initialPermission, setInitialPermission] = useState([]);
    const [existPermission, setExistPermission] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [unChek, setUnChek] = useState(false);
    const navigate = useNavigate();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const handlePermissionChange = (e) => {
        const permissionId = e.target.value;
        const isChecked = e.target.checked;
        if (isChecked) {
            setExistPermission((prevExistpermission) => [
                ...(prevExistpermission || []),
                parseInt(permissionId),
            ]);
        } else {
            const newPermissions = existPermission?.filter(
                (id) => id !== parseInt(permissionId)
            );
            setExistPermission(newPermissions);
        }
    };

    const fetchPermission = useCallback(async () => {
        try {
            const data = await PermissionData(api, authToken, id);
            setPermission(data.AllPermission);
            setInitialPermission(data.AllPermission);
            setExistPermission(data.exist);
        } catch (error) {
            message.error(ErrorExtractor(error));
        }
    }, [api, authToken, id]);

    useEffect(() => {
        fetchPermission();
    }, [fetchPermission]);

    useEffect(() => {
        const allSelected = existPermission?.length === permission?.length;
        setUnChek(allSelected);
        setSelectAll(allSelected);
    }, [existPermission, permission]);
    const handleMultiSelect = (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setSelectAll(true);
            const allPermissionIds = permission.map((p) => p.id);
            setExistPermission(allPermissionIds);
            setUnChek(true);
        } else {
            setSelectAll(false);
            setExistPermission([]);
            setUnChek(false);
        }
    };

    const GivePermission = (e) => {
        setConfirmLoading(true);
        e.preventDefault();
        let ResultData = [...new Set(existPermission)];
        if (ResultData.length > 0) {
            // setBlankError(false);
            apiClient
                .post(
                    `/role-permission/${id}`,
                    {
                        role_id: id,
                        permission_id: ResultData,
                    }
                )
                .then((Response) => {
                    if (Response.data?.status) {
                        message.success("Permission Assign Successfully");
                        setConfirmLoading(false);
                        scrollToTop();
                    }
                })
                .catch((error) => {
                    message.error(ErrorExtractor(error));
                });
        } else {
            message.error("You Have To Select At Least 1 Permission");
            setConfirmLoading(false);
        }
    };

    //model
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [name, setName] = useState('');
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = async () => {
        // setModalText('The modal will be closed after two seconds');
        setConfirmLoading(true);
        try {
            await apiClient.post(`${api}create-permission`, { name }, {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            });
            fetchPermission();
            setConfirmLoading(false);
            handleCancel()
        } catch (error) {
            setConfirmLoading(false);
            handleCancel()
            message.error(ErrorExtractor(error));
        }

    };
    const handleCancel = () => {
        setName("");
        setOpen(false);
    };
    const handleSeach = (e) => {
        const value = e.target.value.toLowerCase();
        if (value) {
            const filteredPermissions = permission.filter(permission =>
                permission.name.toLowerCase().includes(value)
            );
            setPermission(filteredPermissions);
        } else {
            setPermission(initialPermission)
        }
    };

    const HandleView = (value) => {
        setView(value);
    };
    return (
        <>
            <ResponsiveModal
                title="Create New Permission"
                open={open}
                onClose={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" loading={confirmLoading} onClick={handleOk}>
                        OK
                    </Button>
                ]}
            >
                <Form.Item label="Name" className=" my-3">
                    <Input type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="permission name"
                    />
                </Form.Item>
            </ResponsiveModal>
            <PageHeaderAlt className="border-bottom py-2">
                <div className="container-fluid">
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <h3>Assign Permission to {role_name}</h3>
                        <div>
                            {/* View Toggle Switch */}
                            <Space align="center" style={{ marginRight: 8 }}>
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    📋 Accordion
                                </span>
                                <Switch
                                    checked={view === 'Tabs'}
                                    onChange={(checked) => HandleView(checked ? 'Tabs' : 'Accordion')}
                                    checkedChildren="📑"
                                    unCheckedChildren="📋"
                                    size="default"
                                />
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    📑 Tabs
                                </span>
                            </Space>
                            <Button type="primary" className="ml-2" onClick={showModal}>
                                <PlusOutlined />
                                <span>New Permission</span>
                            </Button>
                        </div>
                    </Flex>
                </div>
            </PageHeaderAlt>
            <div className={`my-4 ${view === VIEW_LIST ? "container" : "container-fluid"}`}>
                <Row gutter={16}>
                    <Col xs={24} md={24} className="mb-2">
                        <Flex alignItems="center" justifyContent="space-between">
                            <Flex gap={5}>
                                <ItemHeader name={unChek ? "Deselect All" : "Select All"} />
                                <Checkbox
                                    onChange={(e) => handleMultiSelect(e)}
                                    checked={unChek}
                                />
                            </Flex>
                            <Flex>
                                <Search placeholder="input search text" onChange={(value) => handleSeach(value)} />
                            </Flex>
                        </Flex>
                    </Col>
                </Row>
                <CommionPermissons
                    permission={permission}
                    UserPermission={UserPermission}
                    handlePermissionChange={handlePermissionChange}
                    existPermission={existPermission}
                    selectAll={selectAll}
                    view={view}
                />

                <Flex justifyContent="center" alignItems="center" className="py-4">
                    <Button type="primary" danger onClick={() => navigate('/roles')}>Cancel</Button>
                    <Button
                        type="primary"
                        className="ml-2"
                        onClick={(e) => GivePermission(e)}
                        disabled={confirmLoading}
                    >
                        {/* <PlusOutlined /> */}
                        <span>{confirmLoading ? 'Submitting..' : 'Submit'}</span>
                    </Button>

                </Flex>
            </div>
        </>
    );
};

export default RolePermission;
